import React, { useContext } from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { Column, LocaleContext, Row } from 'shared';
import { required } from 'utils/formValidators';

import { ApplicationFormLabel } from '../../ApplicationForm.styles';
import { EnvSelect } from '../../envSelect/EnvSelect';

import { EnvironmentProps } from './Environment.types';

export const Environment = ({ options }: EnvironmentProps) => {
  const localeContext = useContext(LocaleContext);

  return (
    <Row flexDirection={['column', 'row']} alignItems={['flex-start']} mb="1rem">
      <Column size={[12, 3]}>
        <ApplicationFormLabel>
          {localeContext.formatMessage({ id: 'APPLICATION.FORM.CHOOSE-ENVIRONMENT' })}
        </ApplicationFormLabel>
      </Column>
      <Column size={[12, 9]}>
        <Field name="environment" validate={required(localeContext.formatMessage({ id: 'FORM.SELECTION-REQUIRED' }))}>
          {({ input, meta }: FieldRenderProps<HTMLInputElement>) => (
            <EnvSelect input={input} meta={meta} className="application-form__environment" options={options} />
          )}
        </Field>
      </Column>
    </Row>
  );
};
